import { globalEnv } from "@/constants";
export const oidcSettings = {
  authority: globalEnv.ssoUrl,
  client_id: globalEnv.ssoClientId,
  redirect_uri: `${window.location.origin}/oidc-callback`,
  post_logout_redirect_uri: `${window.location.origin}`,
  response_type: "code",
  scope: "openid profile email",
  automaticSilentRenew: true,
  validateSubOnSilentRenew: true,
  monitorSession: false,
  revokeTokensOnSignout: true,
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 3 * 60,
};
